"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "plaidExchangeCredentials", {
    enumerable: !0,
    get: function() {
        return plaidExchangeCredentials;
    }
});
const PLAID_CREDENTIALS_local = {
    clientId: 'a988b097-5825-4d4b-b7fe-755198ced9fa',
    secret: '208e16d0-b107-4a48-a3b8-d86d8aee8bb1'
};
function plaidExchangeCredentials() {
    return PLAID_CREDENTIALS_local;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90ZXN0L3BsYWlkL3BsYWlkRXhjaGFuZ2VDcmVkZW50aWFscy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBQTEFJRF9DUkVERU5USUFMUyA9IHtcbiAgICBwcmQ6IHsgY2xpZW50SWQ6ICdTRVRfTUUnLCBzZWNyZXQ6ICdTRVRfTUUnIH0sXG4gICAgbG9jYWw6IHtcbiAgICAgICAgY2xpZW50SWQ6ICdhOTg4YjA5Ny01ODI1LTRkNGItYjdmZS03NTUxOThjZWQ5ZmEnLFxuICAgICAgICBzZWNyZXQ6ICcyMDhlMTZkMC1iMTA3LTRhNDgtYTNiOC1kODZkOGFlZThiYjEnLFxuICAgIH0sXG59XG5cbmV4cG9ydCBmdW5jdGlvbiBwbGFpZEV4Y2hhbmdlQ3JlZGVudGlhbHMoKToge1xuICAgIGNsaWVudElkOiBzdHJpbmdcbiAgICBzZWNyZXQ6IHN0cmluZ1xufSB7XG4gICAgcmV0dXJuIFBMQUlEX0NSRURFTlRJQUxTWydsb2NhbCddXG59XG4iXSwibmFtZXMiOlsicGxhaWRFeGNoYW5nZUNyZWRlbnRpYWxzIiwiY2xpZW50SWQiLCJzZWNyZXQiXSwibWFwcGluZ3MiOiI7OzttQ0FRZ0JBOzs7ZUFBQUE7OztBQVJoQixnQ0FFVztJQUNIQyxVQUFVO0lBQ1ZDLFFBQVE7QUFDWjtBQUdHLFNBQVNGO0lBSVo7QUFDSiJ9